import { Flex, Text, Image, Spinner } from "@chakra-ui/react";
import React from "react";

import { iconExtractor } from "../../../helper/iconExtractor";
import {
  DataSource,
  DataSourceType,
} from "../../../types/dataSource/dataSource";

export const ImportStatusIndicator = ({
  selectedDataSource,
  isComplete,
}: {
  selectedDataSource: DataSource;
  isComplete: boolean;
}) => (
  <Flex
    direction="column"
    alignItems="center"
    justifyContent="center"
    h="100%"
    m="10px 25px"
  >
    {isComplete ? (
      <Image src={iconExtractor("complete")} alt="complete" h="70px" />
    ) : (
      <Spinner
        color="red.500"
        emptyColor="red.200"
        my="10px"
        thickness="5px"
        size="xl"
      />
    )}
    <Text
      fontSize="1.375rem"
      fontWeight="bold"
      color="black.900"
      my="30px"
      textAlign="center"
    >
      {isComplete
        ? "Import Successful"
        : `Your ${
            selectedDataSource.type === DataSourceType.Custom
              ? ""
              : selectedDataSource.name
          } data is being imported as we speak`}
    </Text>
    <Text fontSize="1rem" color="black.600" mb="20px" textAlign="center">
      Exciting stuff! You are well on your way to having your crypto taxes under
      control.
    </Text>
    {!isComplete && (
      <Text fontSize="1rem" color="black.600" mb="20px" textAlign="center">
        We are currently syncing your files to Syla. This might just take a few
        minutes.
      </Text>
    )}
  </Flex>
);
